import { render } from "./TemplateGridView.vue?vue&type=template&id=508a8633&scoped=true"
import script from "./TemplateGridView.vue?vue&type=script&lang=ts"
export * from "./TemplateGridView.vue?vue&type=script&lang=ts"

import "./TemplateGridView.vue?vue&type=style&index=0&id=508a8633&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-508a8633"

export default script